module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-vehicle-damage-detail"
  }, [_c('div', {
    ref: "damageContainer",
    staticClass: "damage-container"
  }, [_c('img', {
    staticClass: "car-outline",
    attrs: {
      "src": _vm.vehicleDamagePicture
    }
  }), _vm._l((_vm.pins), function(pin) {
    return _c('div', {
      staticClass: "component-pin",
      class: {
        'is-expanded': pin.expanded, hover: pin.hover, 'status-PENDING_REVIEW': true
      },
      style: ({
        backgroundColor: pin.status === 'PENDING_REVIEW' ? '#ffc200' : '#2890ff',
        top: pin.top + 'px',
        left: pin.left + 'px'
      }),
      on: {
        "mouseover": function($event) {
          return _vm.selectHovered(pin)
        },
        "mouseleave": _vm.resetHover
      }
    }, [_c('div', {
      on: {
        "click": function($event) {
          pin.expanded = !pin.expanded
        }
      }
    }, [_c('small', [_vm._v(_vm._s(pin.id))])]), (pin.expanded) ? _c('div', {
      staticClass: "expanded",
      on: {
        "click": function($event) {
          pin.expanded = !pin.expanded
        }
      }
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "column"
    }, [_c('label', [_vm._v("ID")]), _c('router-link', {
      attrs: {
        "to": {
          name: 'reporting',
          params: {
            id: pin.id
          }
        },
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(pin.id))])], 1), _c('div', {
      staticClass: "column"
    }, [_c('label', [_vm._v("UID")]), _c('div', {
      staticClass: "value"
    }, [_vm._v(_vm._s(pin.uid))])]), _c('div', {
      staticClass: "column"
    }, [_c('label', [_vm._v("Status")]), _c('div', {
      staticClass: "value"
    }, [_vm._v(_vm._s(pin.status))])])]), _c('hr'), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "column"
    }, [_c('label', [_vm._v("Description")]), _c('p', [_vm._v(_vm._s(pin.description))])])])]) : _vm._e()])
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-220b29c5!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/VehicleDamageDetail.vue
// module id = 2134
// module chunks = 1